import { useMutation } from '@northladder/services';
import {
  ErrorEventsEnum,
  errorLogToRemoteUtil,
  IApiError,
} from '@northladder/utilities';

import { ISendUserLoginOPTData } from '../types';
import { USER_ACCOUNTS_API } from '../userAccountsAPIClient';

/**
 * This is to track the sent login otp mutation keys in react query cache.
 */
const MUT_SEND_USER_LOGIN_OTP = 'send-user-login-otp';

interface ISendUserLoginOTPOptions {
  onErrorCallback: (err: IApiError) => void;
  onSuccessCallback: (otpData: ISendUserLoginOPTData) => void;
}

/**
 * This performs an otp generation request on the server that is sent to the
 * user's mobile to get the OTP used during user login with phone number.
 */
export const useSendUserLoginOTPMutation = ({
  onSuccessCallback,
  onErrorCallback,
}: ISendUserLoginOTPOptions) => {
  const { mutate, isPending, error } = useMutation({
    mutationKey: [MUT_SEND_USER_LOGIN_OTP],
    networkMode: 'always',
    retry: false,
    mutationFn: USER_ACCOUNTS_API.sendUserLoginOTP,
    onSuccess: onSuccessCallback,
    onError: (err: IApiError) => {
      onErrorCallback(err);
      errorLogToRemoteUtil({
        error,
        errorCode: ErrorEventsEnum.ERROR_IN_API_CALL,
        errorTitle: 'useSendUserLoginOTPMutation: Error',
        message: err.message,
      });

      return err;
    },
  });

  return {
    error,
    isPending,
    sendUserLoginOTP: mutate,
  };
};
